import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class AboutHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            banners : [],
            categories : this.props.categories,
            loading : 1,
            products:0,
            settings:{}
        }
        

    }

    componentDidMount()
    { 
        this.setState({loading:0});
    }


    render()
    { 
        
         if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        <div class="ul-container">
            <section class="ul-categories">
                <div class="ul-inner-container">
                    <div class="row row-cols-lg-4 row-cols-md-3 row-cols-2 row-cols-xxs-1 ul-bs-row">

                        {this.state.categories.map((item,key)=>( 
                            
                        <div class={item.parent_id > 0 ? "dnone" : "col"}>
                            <Link class="ul-category" to={base_url+"category/"+item.slug}>
                                <div class="ul-category-img">
                                   <img src={item.icon} alt={item.name} />
                                </div>
                                <div class="ul-category-txt">
                                    <span>{item.name}</span>
                                </div>
                                <div class="ul-category-btn">
                                    <span><i class="flaticon-arrow-point-to-right"></i></span>
                                </div>
                            </Link>
                        </div>

                        ))}
 


                    </div>
                </div>
            </section>
        </div>
    );
}

}

export default AboutHome;